// v1.29.99 — Single source of truth for UTR validation.
// A valid UTR is EXACTLY 12 numeric digits — no letters, dots, spaces or
// special characters. Used across every UTR / reference entry point.
export const UTR_LEN = 12;
export const UTR_REGEX = /^\d{12}$/;

// Strip everything that isn't a digit and cap at 12 chars. Wire this into
// onChange so invalid characters can never be typed into a UTR field.
export const sanitizeUtr = (v) => (v || "").replace(/\D/g, "").slice(0, UTR_LEN);

export const isValidUtr = (v) => UTR_REGEX.test((v || "").trim());

export const UTR_FORMAT_ERROR = "UTR must be a 12-digit number";
export const UTR_UPLOAD_FORMAT_ERROR =
    "Invalid UTR number. Please enter the 12-digit numeric UTR from your payment confirmation";
export const UTR_DUPLICATE_ERROR =
    "This UTR number already exists in our records. Please check and try again";
